export enum KnownExceptionStatuses {
  None = 'none',
  Existent = 'existent'
}

export const HAS_NO_EXCEPTIONS_FILTER_OPTION = {
  id: 'hasNoExceptions',
  label: 'No Exceptions'
}
